import { render, staticRenderFns } from "./DashboardMainCategory.vue?vue&type=template&id=2094930d&scoped=true&"
import script from "./DashboardMainCategory.vue?vue&type=script&lang=js&"
export * from "./DashboardMainCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2094930d",
  null
  
)

export default component.exports